module.exports = __webpack_public_path__ + "img/type_40_3.prt.fac32d21.jpg";